var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenVpn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "currentColor",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-vpn__Integration=OpenVPN, Size=48",
    className: "open-vpn__Integration=OpenVPN, open-vpn__Size=48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-vpn__Integrations",
    className: "open-vpn__Integrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-vpn__Vector",
    className: "open-vpn__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A3967",
    d: "M27.442 24.282c0-1.889-1.541-3.42-3.49-3.42-1.95 0-3.49 1.526-3.49 3.42 0 .7.217 1.382.623 1.95a3.33 3.33 0 0 0 1.64 1.22l-1.372 7.02h5.15l-1.325-7.02c1.324-.509 2.264-1.695 2.264-3.171Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA7D1F",
    d: "M35 24.231c0-5.905-4.933-10.702-11-10.702-6.066 0-11 4.792-11 10.702 0 3.922 2.165 7.336 5.392 9.174l.692-4.575a6.286 6.286 0 0 1-1.685-4.235c0-3.51 2.937-6.366 6.547-6.366 3.609 0 6.547 2.856 6.547 6.367a6.317 6.317 0 0 1-1.678 4.285l.697 4.575C32.81 31.616 35 28.155 35 24.233"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenVpn);
export default __webpack_public_path__ + "static/media/OpenVPN.38c734a3f0709d8a1a8247ea987cb523.svg";
export { ForwardRef as ReactComponent };